import { render, staticRenderFns } from "./MatterbridgeIntegration.vue?vue&type=template&id=2c965b04&scoped=true&"
import script from "./MatterbridgeIntegration.vue?vue&type=script&lang=js&"
export * from "./MatterbridgeIntegration.vue?vue&type=script&lang=js&"
import style0 from "./MatterbridgeIntegration.vue?vue&type=style&index=0&id=2c965b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c965b04",
  null
  
)

export default component.exports